import * as types from '../types';
import { ITaxRatesApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class TaxRatesHttpApi extends HttpApi implements ITaxRatesApi {
  async listTaxRates(): Promise<types.TaxRate[]> {
    // Backend returns every tax rate for the tenant in one unpaginated array.
    const response = await this.http.get<types.APIResponse<types.TaxRate[]>>('/tax-rates');
    return response.data.data;
  }

  async getTaxRate(id: string): Promise<types.TaxRate> {
    const response = await this.http.get<types.APIResponse<types.TaxRate>>(`/tax-rates/${id}`);
    return response.data.data;
  }

  async createTaxRate(data: types.CreateTaxRateRequest): Promise<types.TaxRate> {
    const response = await this.http.post<types.APIResponse<types.TaxRate>>('/tax-rates', data);
    return response.data.data;
  }

  async updateTaxRate(id: string, data: types.UpdateTaxRateRequest): Promise<types.TaxRate> {
    const response = await this.http.patch<types.APIResponse<types.TaxRate>>(`/tax-rates/${id}`, data);
    return response.data.data;
  }

  async deleteTaxRate(id: string): Promise<void> {
    await this.http.delete(`/tax-rates/${id}`);
  }
}
